<template>
    <div>
        <div class="product-chip-wrapper" v-if="productList && productList.length > 0 && productList[0]">
            <div class="product-chip"  v-for="item in productList" :key="item">{{ item }}</div>
        </div>
        <input v-else disabled type="text" class="form-control search">
    </div>
</template>

<script>
export default {
    name: 'ProductListChipView',
    data() {
        return {
            productChipList:[]
        }
    },
    props: {
        productList: {
            type: Array
        }
    },
    watch: {
        productList() {
            if (this.productList[this.productList.length - 1] == '') {
                this.productList.splice(this.productList.length - 1, 1)
                console.log(this.productList)
            }
        }
    }
}
</script>

<style lang="scss">
.product-chip-wrapper {
    border: 1px solid #cfcece;
    padding:5px;
    max-height: 120px;
    overflow-y: auto;
    border-radius: 5px;
}
.product-chip {
  display: inline-block;
  padding: 0 20px;
  height: 40px;
  font-size: 16px;
  line-height: 40px;
  border-radius: 25px;
  margin:2px;
  background-color: #f1f1f1;
}


</style>
